<template>
  <div class="mt-4 ml-1">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/admin/dashboard' }"
          >管理中心
        </el-breadcrumb-item>
        <el-breadcrumb-item>文章内容</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/admin/mainContent/jobList' }"
          >招聘列表
        </el-breadcrumb-item>
        <el-breadcrumb-item
          ><span class="text-primary">招聘详情</span></el-breadcrumb-item
        >
      </el-breadcrumb>
    </el-row>
    <el-card class="my-3 mx-1">
      <div slot="header">
        <span class="font-weight-bold text-primary">招聘详情</span>
      </div>
      <div style="height: 470px;overflow-y: auto;padding-right: 60px">
        <el-form :model="jobInfo" class="font-weight-bold" label-width="120px">
          <el-form-item label="职位名称">
            <el-input v-model="jobInfo.jobName"></el-input>
          </el-form-item>
          <el-form-item label="是否发布">
            <el-radio-group v-model="jobInfo.jobStatus">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="首页展示">
            <el-radio-group v-model="jobInfo.homeShow">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="访问量">
            <el-input v-model="jobInfo.jobViews"></el-input>
          </el-form-item>
          <el-form-item label="招聘内容">
            <my-editor v-model="jobInfo.jobContent"></my-editor>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitJobForm(jobInfo)"
              >立即提交
            </el-button>
            <el-button @click="resetForm()">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<!--suppress JSUnresolvedVariable -->
<script>
import MyEditor from "../../components/common/MyEditor";
export default {
  name: "JobForm",
  data() {
    return {
      jobId: this.$route.params.jobId,
      jobInfo: {}
    };
  },
  components: {
    MyEditor
  },
  mounted() {
    if (this.jobId !== 0) {
      this.getJobById();
    }
  },
  methods: {
    getJobById() {
      this.axios
        .get("/job/getJobById", {
          params: {
            jobId: this.jobId
          }
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.jobInfo = resp.data.data;
          }
        });
    },
    resetForm() {
      this.$router.push({ name: "JobList" }).catch();
    },
    submitJobForm(jobInfo) {
      this.axios
        .post("/job/admin/addOrUpdateJob", {
          jobId: jobInfo.jobId,
          jobName: jobInfo.jobName,
          jobViews: jobInfo.jobViews,
          jobStatus: jobInfo.jobStatus,
          homeShow: jobInfo.homeShow,
          jobContent: jobInfo.jobContent
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.$notify({
              title: "成功",
              message: "操作成功",
              type: "success"
            });
            this.$router.push({ name: "JobList" }).catch();
          } else {
            this.$notify.error({
              title: "错误",
              message: "操作失败！"
            });
          }
        });
    }
  }
};
</script>

<style scoped></style>
